export default "<label ng-class=\"{required: field.type_flags.required, match: field.type_flags.match_scheduled}\">{{field.display_name}}</label>";